import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/image/png/kafsh.svg'


const _hoisted_1 = { class: "w-full h-[90px] flex items-center justify-between px-7" }
const _hoisted_2 = { class: "w-full flex flex-col my-3" }
const _hoisted_3 = { class: "w-full flex items-center justify-center" }
const _hoisted_4 = { class: "w-10 text-primary700" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs md:text-sm font-semibold" }, "ویرایش پروفایل", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-header",
  class: "h-[85px] object-cover pt-2"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "absolute -top-2 -right-1 w-[20px] h-[20x] bg-primary300 rounded-full text-white text-sm flex items-center justify-center"
}

import { ref } from 'vue';
import BaseAvatar from '../Avatar/BaseAvatar.vue';
import MenuList from "@/components/global/menuList/MenuList.vue"
import BasePopupMenu from '../Popup/BasePopupMenu.vue';
import { Popups } from "@/stores/Popup"
import BaseBtn from '../button/baseBtn.vue';
import PopupProfile from '../profile/PopupProfile.vue';
import { DashboardAuth } from "@/stores/Auth/dashboardAuth"
import EditProfile from '../profile/EditProfile.vue';
import IconEditProfile from '@/components/icon/IconEditProfile.vue';
import IconPassword from '@/components/icon/IconPassword.vue';
import IconNotif from '@/components/icon/IconNotif.vue';
import router from '@/router';
import IconEditUser from '@/components/icon/IconEditUser.vue';
import { DataBadgeNotif } from '@/stores/Notif/BadgeNotif';
import BaseInfoUser from "@/components/global/infoUser/BaseInfoUser.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeader',
  setup(__props) {

const dataListMenu = ref(require("@/json/Menu.json"))

const dataPopup = Popups()

const dataDashboard = DashboardAuth()
dataDashboard.CheckAuthUser()

const dataBadge = DataBadgeNotif()
if (window.navigator.onLine) {
    dataBadge.GetDateBadge()
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(dataPopup).showMenuPopup = true)),
        class: "w-12 h-12"
      }, [
        _createVNode(BaseBtn, {
          type: "button",
          "style-btn": "btn-primery-rounded-profile",
          icon: require('@/assets/image/icons/category.svg')
        }, null, 8, ["icon"])
      ]),
      _createVNode(BasePopupMenu, {
        status: _unref(dataPopup).showMenuPopup,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_unref(dataPopup).showMenuPopup = false))
      }, {
        profile: _withCtx(() => [
          _createVNode(BaseInfoUser, {
            "src-avatr": _unref(dataDashboard).dataUser.avatar,
            firstName: _unref(dataDashboard).dataUser.firstName,
            "last-name": _unref(dataDashboard).dataUser.lastName,
            phone: _unref(dataDashboard).dataUser.mobile,
            "col-box": true
          }, null, 8, ["src-avatr", "firstName", "last-name", "phone"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(dataPopup).handelEditProfile())),
                class: "w-1/3 h-[70px] flex flex-col items-center justify-between cursor-pointer"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(IconEditUser)
                ]),
                _hoisted_5
              ])
            ])
          ])
        ]),
        pannel: _withCtx(() => [
          _createVNode(MenuList, {
            "data-list-sidebar": dataListMenu.value,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(dataPopup).showMenuPopup = false))
          }, null, 8, ["data-list-sidebar"])
        ]),
        _: 1
      }, 8, ["status"]),
      _createElementVNode("div", {
        class: "Logo cursor-pointer",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push({ name: 'ContactPage' })))
      }, _hoisted_7),
      _createElementVNode("div", {
        class: "cursor-pointer text-primary300 w-10 h-10 relative",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push({ name: 'NotificationsPage' })))
      }, [
        (_unref(dataBadge).countUnread !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(dataBadge).countUnread), 1))
          : _createCommentVNode("", true),
        _createVNode(IconNotif)
      ])
    ]),
    _createVNode(PopupProfile, {
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_unref(dataPopup).showProfile = false))
    }),
    _createVNode(EditProfile)
  ], 64))
}
}

})